module.exports = __webpack_public_path__ + "14_hair_gold.d9898011.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/14_hair_gold.png
// module id = pHoS
// module chunks = 0